import { DcBaseComponent } from '@deleteagency/dc';
import { load } from './add-this-script';

export default class ShareToolboxComponent extends DcBaseComponent {
    static getNamespace() {
        return 'share-toolbox';
    }

    onInit() {
        load();
    }
}
